import React from "react";
import TableView from "../../tables/TableView";
import AddNewButton from "../../buttons/AddNewButton";
import useTableData from "../useTableData";
import ListViewCommon from "../ListViewCommon";

const headers = [
    {"label": "Nazov", "caption": "Názov", 'filter': 'string'}
]


function ServiceCaseTypes(props) {
    const baseUrl = '/service_case/service_cases_types'
    const baseUrlFrontend = '/service_case_types/service_case_type'
    const initialFilters = [
        {
            'label': 'Nazov',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Nazov',
        }
    ]
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Nazov': `${baseUrlFrontend}/${entry.id}`
        }))
    }

    return (
        <ListViewCommon baseUrlFrontend={baseUrlFrontend}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Typy Servisu"}
        />
        // <div>
        //     <TableView links={links} headers={headers} data={data} delete_single={delete_single} label="Typy servisných prípadov"/>
        //     <AddNewButton link={`${baseUrlFrontend}/new`}/>
        // </div>
    )
}

export default ServiceCaseTypes
